import Profile from "../../pages/Profile.jsx";

export default Profile;
